import { createSelector } from 'react-sweet-state';

import { ValidationFieldSet } from '../../../../common/types/field-validation';
import type { FieldId } from '../../../../common/types/form/form-fields';
import { FormFieldType } from '../../../../common/types/form/form-fields';
import type { FormRendererState } from '../../types';

export interface FieldValidationEnabledSelectorProps {
	fieldId: FieldId;
}

const SECURITY_CRITICAL_FIELD_TYPES = new Set<FormFieldType>([
	FormFieldType.URL,
	FormFieldType.EMAIL,
]);

/*
 * Selector to get whether validation is enabled for a field
 */
export const fieldValidationEnabledSelector: import('react-sweet-state').OutputSelector<
	FormRendererState,
	FieldValidationEnabledSelectorProps,
	boolean
> = createSelector(
	(state: FormRendererState) => state.fieldValidation,
	(state: FormRendererState) => state.modifiedValues,
	(state: FormRendererState) => state.formFields,
	(_, props: FieldValidationEnabledSelectorProps) => props.fieldId,
	(fieldValidation, modifiedValues, formFields, fieldId) => {
		if (fieldValidation.validationTargets?.fieldIds?.includes(fieldId)) {
			return true;
		}
		if (fieldValidation.validationTargets?.fieldSet === ValidationFieldSet.ALL_FIELDS) {
			return true;
		}
		if (
			fieldValidation.validationTargets?.fieldSet === ValidationFieldSet.MODIFIED_FIELDS &&
			modifiedValues[fieldId] !== undefined
		) {
			return true;
		}
		if (fieldValidation.validationTargets?.fieldSet === ValidationFieldSet.SECURITY_CRITICAL) {
			const field = formFields[fieldId];
			return field !== undefined && SECURITY_CRITICAL_FIELD_TYPES.has(field.type as FormFieldType);
		}
		return false;
	},
);
